import { Component } from "@angular/core";

import { BrowserWidthService } from "../../services/browser-width.service";

@Component({
    selector: 'dim-background',
    template: `<div *ngIf="(browserWidthService.disableBackground$ | async)" [ngStyle]="style"></div>`
})

export class DimBackgroundComponent {

    constructor(
        public browserWidthService: BrowserWidthService
    ) {}

    get style() {
        return {
            'position': 'fixed',
            'width': `${this.browserWidthService.getDisplayMode().width.innerWidth}px`,
            'height': `${this.browserWidthService.getDisplayMode().width.innerHeight}px`,
            'z-index': 502,
            'background-color': 'rgba(0, 0, 0, 0.25)'
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/dim-background/dim-background.component.ts